import AutomateExperience from "../components/AutomateExperience.jsx";

/**
 * Standalone /automate-my-work route (no Layout shell).
 * Shares UI with Layout-wrapped /ai-automations via AutomateExperience.
 */
export default function Automate({ company }) {
  return <AutomateExperience company={company} embeddedInLayout={false} />;
}
